<div class="center-small-container">
  @if (!isMobile) {
    <h1 class="page-title-center">My Companies</h1>
  }

  @if (loading()) {
    <mat-progress-bar mode="indeterminate" class="mt-25"></mat-progress-bar>
  }

  @if (!loading()) {
    @if(activeCarrierConnection()){
      <div class="green-container text-center">
        You can post trucks and search loads.
      </div>
    } @else {
      <div class="red-container text-center">
        Connect with an active carrier to post trucks and search loads.
      </div>
    }

    @if(activeBrokerConnection()){
      <div class="green-container text-center">
        You can post loads and search trucks.
      </div>
    } @else {
      <div class="red-container text-center">
        Connect with an active broker to post loads and search trucks.
      </div>
    }

    @if (connections.length === 0) {
      <div class="yellow-container text-center mt-15">
        No companies connected yet.
      </div>
    } @else {
      @for (connection of connections; track connection.id) {
        <div class="grey-container">
          <div class="carrier-text">
            @if (!connection.carrier.dba_name) {
              {{ connection.carrier.legal_name }}<br />
            } @else {
              {{ connection.carrier.dba_name }}<br />
            }

            {{ connection.carrier.docket_prefix }} {{ connection.carrier.docket_number }}<br />

            {{ getCarrierType(connection.carrier) }}<br />

            <span class="connection-email">
              {{ connection.email }}
            </span>
          </div>

          <div class="carrier-actions">
            <button
              class="edit-button"
              mat-icon-button
              type="button"
              matTooltip="Edit connection"
              (click)="updateConnection(connection)"
            >
              <mat-icon>edit</mat-icon>
            </button>

            <button
              class="danger-button"
              mat-icon-button
              type="button"
              matTooltip="Leave the company"
              (click)="deleteConnection(connection)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      }
    }
  }

  <button
    mat-flat-button
    class="main-button-squared-full-width lightyellow"
    routerLink="/account/connection"
  >
    Search Company
  </button>
</div>